import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "../../components/Form";
import { TextInput } from "../../components/Inputs";
import { useTranslations } from "../../providers/useTranslations";
import { getPostCodeValidationRules } from "../../utils/getPostCodeValidationRules/getPostCodeValidationRules";
const defaultPostCodeConfig = {
    postcode_validation_enabled: false,
    postcode_is_required: true,
    postcode_min_length: 0,
    postcode_max_length: 0,
    postcode_validate_regex: "",
    shouldHidePostCode: false,
};
export const PostCode = ({ fieldName = (name) => name, config = defaultPostCodeConfig }) => {
    const { __ } = useTranslations();
    const { control } = useFormContext();
    if (config?.shouldHidePostCode) {
        return null;
    }
    const validationRules = getPostCodeValidationRules(config, __);
    return (_jsx(Controller, { name: fieldName("postcode"), rules: validationRules, control: control, render: ({ field, fieldState: { error } }) => (_jsx(TextInput, { ...field, dataTestId: "postcode", placeholder: __("address_fields.postcode_placeholder"), label: __("address_fields.postcode"), showRequiredAsterisk: config.postcode_is_required, isError: !!error, isHelperTextVisible: !!error, errorText: error?.message })), defaultValue: "" }));
};
//# sourceMappingURL=PostCode.js.map